export const GAME_CONFIG = {
  boardSize: 15,
  rackSize: 7,
  minWordLength: 2,
  centerTileId: '7,7',
  maxRounds: 15,
  actConfig: {
    roundsPerAct: 3,
    actCount: 5,
  },
  roundEconomy: {
    submitsPerRound: 4,
    discardsPerRound: 2,
  },
  wordLengthBonus: {
    minLength: 4,
    bonusPerTile: 3,
  },
  player: {
    id: 'solo-player',
    defaultName: 'Score',
  },
};

export const ROUND_SCORE_TARGETS = [
  25,  50,  75,
  50,  75,  100,
  75,  100, 125,
  100, 125, 150,
  125, 150, 175,
];

export const ROUND_TILE_TARGETS = [
  6, 9, 12,
  7, 10, 13,
  8, 11, 14,
  9, 12, 15,
  10, 13, 16,
];

export const LETTER_POINTS = {
  A: 1,
  B: 3,
  C: 3,
  D: 2,
  E: 1,
  F: 4,
  G: 2,
  H: 4,
  I: 1,
  J: 8,
  K: 5,
  L: 1,
  M: 3,
  N: 1,
  O: 1,
  P: 3,
  Q: 10,
  R: 1,
  S: 1,
  T: 1,
  U: 1,
  V: 4,
  W: 4,
  X: 8,
  Y: 4,
  Z: 10,
};

export const VOWELS = ['A', 'E', 'I', 'O', 'U'];

export const BAG_PRESETS = {
  CLASSIC: {
    id: 'classic',
    label: 'Classic',
    description: 'Standard Scrabble tile distribution (98 tiles).',
  },
  RANDOM: {
    id: 'random',
    label: 'Random',
    description: 'Same number of tiles as Classic, randomly drawn from the alphabet (~42% vowels).',
  },
  TEST: {
    id: 'test',
    label: 'Test',
    description: 'Current compact test bag setup.',
  },
};

export const BAG_PRESET_OPTIONS = [
  BAG_PRESETS.CLASSIC,
  BAG_PRESETS.RANDOM,
  BAG_PRESETS.TEST,
];

export const DEFAULT_BAG_PRESET = BAG_PRESETS.CLASSIC.id;